/**
 * Making the emoji Meta sends actually render.
 *
 * Reactions arrive as bare code points. A heart comes through as U+2764 with
 * no variation selector, and U+2764 on its own is a *text* glyph: the browser
 * draws a thin monochrome outline, or in many fonts nothing at all — which is
 * how a reaction ended up showing as an empty white pill.
 *
 * Unicode's rule is that a character which is Emoji but not
 * Emoji_Presentation defaults to text and needs U+FE0F after it to be drawn
 * in colour. Newer emoji (👍 U+1F44D) already default to emoji presentation
 * and must be left alone — appending to those is harmless but pointless, and
 * appending to a non-emoji would corrupt it.
 */
/** U+FE0F: "draw the character before me as an emoji, not as text." */
const VARIATION_SELECTOR = '️';
/**
 * The same emoji, with the variation selector added where Unicode needs one.
 *
 * Idempotent: a string that already carries the selector comes back unchanged,
 * so this is safe to apply on the way in and again on the way out.
 */
export function renderableEmoji(emoji) {
    if (!emoji)
        return '';
    let out = '';
    const points = [...emoji];
    for (let i = 0; i < points.length; i += 1) {
        const point = points[i];
        out += point;
        if (point === VARIATION_SELECTOR)
            continue;
        if (points[i + 1] === VARIATION_SELECTOR)
            continue;
        // Emoji, but one that would otherwise be drawn as plain text.
        if (/\p{Emoji}/u.test(point) && !/\p{Emoji_Presentation}/u.test(point)) {
            out += VARIATION_SELECTOR;
        }
    }
    return out;
}
//# sourceMappingURL=emoji.js.map